export default __webpack_public_path__ + "static/tag-dont-2-light-ea5f36663d1b54541dc130c1081aa34c114a483e549aec6d0e43e32f346d73b3.png";